import { useState } from "react";
import { Loader2, PhoneIncoming, CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

// Callback request (name + phone + privacy consent) attached to the availability request "Da verificare"
export default function CallbackForm({ requestId, ensureRequestId }) {
  const [form, setForm] = useState({ name: "", phone: "", privacy: false });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [showPrivacy, setShowPrivacy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.privacy) return setError("Per inviare la richiesta devi accettare l'informativa privacy.");
    setSending(true);
    try {
      const id = requestId || (await ensureRequestId?.());
      if (!id) throw { response: { data: { detail: "Connessione non riuscita: riprova o chiamaci al +39 351 426 9681." } } };
      await api.post(`/availability-requests/${id}/callback`, { name: form.name, phone: form.phone, privacy_accepted: form.privacy });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Invio non riuscito, riprova o chiamaci.");
    } finally { setSending(false); }
  };

  if (sent) {
    return (
      <div data-testid="callback-success" className="mb-6 p-4 border border-[#22ff66]/40 bg-[#22ff66]/10 flex items-start gap-3 text-sm">
        <CheckCircle2 className="w-5 h-5 text-[#22ff66] shrink-0" />
        <span>Richiesta inviata! Ti richiameremo al più presto per confermare disponibilità e tariffa.</span>
      </div>
    );
  }

  const input = "w-full h-11 bg-black/40 border border-white/20 focus:border-[#22ff66] outline-none px-3 text-sm text-white placeholder:text-white/40";
  return (
    <form data-testid="callback-form" onSubmit={submit} className="mb-6 p-4 border border-white/10 bg-white/[0.03]">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest font-bold text-[#22ff66] mb-3"><PhoneIncoming className="w-4 h-4" /> Preferisci essere richiamato?</div>
      <div className="grid sm:grid-cols-2 gap-2 mb-3">
        <input data-testid="callback-name" required maxLength={80} autoComplete="name" placeholder="Nome e cognome" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} />
        <input data-testid="callback-phone" required type="tel" inputMode="tel" autoComplete="tel" placeholder="Telefono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={input} />
      </div>
      <label className="flex items-start gap-2 text-xs text-white/75 mb-2 cursor-pointer">
        <input data-testid="callback-privacy" type="checkbox" checked={form.privacy} onChange={(e) => setForm({ ...form, privacy: e.target.checked })} className="mt-0.5 accent-[#22ff66]" />
        <span>Ho letto l'<button type="button" data-testid="callback-privacy-toggle" onClick={() => setShowPrivacy((v) => !v)} className="underline font-semibold text-white">informativa privacy</button> e acconsento al trattamento dei miei dati per essere ricontattato.</span>
      </label>
      {showPrivacy && (
        <div data-testid="callback-privacy-text" className="text-[11px] leading-relaxed text-white/60 mb-3 p-3 bg-black/40 border border-white/10 max-h-32 overflow-y-auto">
          Informativa ai sensi dell'art. 13 Reg. UE 2016/679 (GDPR). Titolare del trattamento: UTILE RENT. I dati (nome, telefono, vettura, date e prezzo visualizzato) sono trattati al solo fine di ricontattarti per verificare disponibilità e tariffe della prenotazione richiesta (base giuridica: misure precontrattuali su tua richiesta, art. 6.1.b). Non sono ceduti a terzi né usati per marketing, e sono conservati per il tempo necessario a gestire la richiesta e comunque non oltre 12 mesi. Puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione e opposizione (artt. 15-22) scrivendo a info@utile-rent.com, e proporre reclamo al Garante Privacy.
        </div>
      )}
      {error && <div data-testid="callback-error" className="text-xs text-[#ff6b6b] mb-2">{error}</div>}
      <button type="submit" data-testid="callback-submit" disabled={sending} className="w-full h-11 bg-white text-black text-xs uppercase tracking-widest font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60">
        {sending && <Loader2 className="w-4 h-4 animate-spin" />} Richiedi una richiamata
      </button>
    </form>
  );
}
